import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { bodyFontFamily, headerFontFamily } from "styles/theme/mui";
import { homeHeaderTypography } from "../../styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionTitle: {
      ...homeHeaderTypography,
      fontSize: "16px !important",
      fontWeight: "600 !important",
      lineHeight: "23.12px !important",
      color: theme.palette.secondary.main,
      marginBottom: "10px !important",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)",
      gap: 14,
    },

    card: {
      background: theme.palette.background.paper,
      borderRadius: 4,
      minHeight: 138,
      padding: "12px 14px",
      boxSizing: "border-box",
      border: `1px solid ${theme.palette.divider}`,
    },

    cardHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 8,
    },

    vehicleIcon: {
      width: 28,
      height: 28,
      borderRadius: "50%",
      background: theme.palette.grey[400],
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.secondary.main,

      "& svg": {
        fontSize: 18,
      },
    },

    vehicleName: {
      fontSize: "14px !important",
      fontWeight: "700 !important",
      color: theme.palette.secondary.main,
      fontFamily: headerFontFamily,
    },

    divider: {
      height: 1,
      width: "100%",
      background: theme.palette.divider,
      margin: "10px 0",
    },

    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 8,
    },

    label: {
      fontSize: "12px !important",
      color: theme.palette.text.primary,
      fontWeight: "500 !important",
      fontFamily: bodyFontFamily,
    },

    value: {
      fontSize: "12px !important",
      color: theme.palette.text.primary,
      fontWeight: "700 !important",
      fontFamily: bodyFontFamily,
    },

    link: {
      fontSize: "12px !important",
      color: theme.palette.primary.main,
      fontWeight: "700 !important",
      textDecoration: "underline",
      cursor: "pointer",
      fontFamily: bodyFontFamily,
    },
  })
);
